export const CAPABILITIES_KEY_BASE = 'capabilities';
export const BILLING_CAPABILITIES = 'billing_capabilities';
export const MEMBERS_CAPABILITIES = 'members_capabilities';
export const SERVICE_ACCOUNTS_CAPABILITIES = 'service_accounts_capabilities';
export const ALLOWED_STORAGE_CAPABILITIES = 'allowed_storage_capabilities';
export const DEVELOPER_PLATFORM_CAPABILITIES = 'developer_platform_capabilities';
export const GUEST_LINKS_CAPABILITIES = 'guest_links_capabilities';
export const CapabilitiesKeyFactory = {
    all: () => [CAPABILITIES_KEY_BASE],
    billingCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        BILLING_CAPABILITIES,
        workspaceId,
    ],
    membersCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        MEMBERS_CAPABILITIES,
        workspaceId,
    ],
    serviceAccountsCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        SERVICE_ACCOUNTS_CAPABILITIES,
        workspaceId,
    ],
    allowedStorageCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        ALLOWED_STORAGE_CAPABILITIES,
        workspaceId,
    ],
    developerPlatformCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        DEVELOPER_PLATFORM_CAPABILITIES,
        workspaceId,
    ],
    guestLinksCapabilities: (workspaceId) => [
        ...CapabilitiesKeyFactory.all(),
        GUEST_LINKS_CAPABILITIES,
        workspaceId,
    ],
};
